module.exports = __webpack_public_path__ + "img/Monte_Kope_62.d2b181f7.jpg";